export default __webpack_public_path__ + "static/media/1513.9a821c65.png";